// extracted by mini-css-extract-plugin
module.exports = {"root":"_3yx5q","copyright":"_3yyIg"};